import OperatorListingFilter, {
  OperatorListingEmailFilter,
  OperatorListingFirstNameFilter,
  OperatorListingLastNameFilter,
  OperatorListingStatusFilter,
  OperatorListingUsernameFilter,
} from "./types/operator-listing-filter";
import OperatorListingFilterType from "./types/operator-listing-filter-type";
import OperatorListingSortKey from "./types/operator-listing-sort-key";
import UserOperatorListParams from "../../../../../common/services/user/operator/list/user-operator-list-params";
import UserOrder from "../../../../../common/types/user-order";

const createOrder = (
  sortKey: OperatorListingSortKey | null,
): UserOrder | undefined => {
  const definition: Record<OperatorListingSortKey, UserOrder> = {
    [OperatorListingSortKey.FIRST_NAME_ASC]: UserOrder.FIRST_NAME_ASC,
    [OperatorListingSortKey.FIRST_NAME_DESC]: UserOrder.FIRST_NAME_DESC,
    [OperatorListingSortKey.LAST_NAME_ASC]: UserOrder.LAST_NAME_ASC,
    [OperatorListingSortKey.LAST_NAME_DESC]: UserOrder.LAST_NAME_DESC,
    [OperatorListingSortKey.USERNAME_ASC]: UserOrder.USERNAME_ASC,
    [OperatorListingSortKey.USERNAME_DESC]: UserOrder.USERNAME_DESC,
  };

  return sortKey ? definition[sortKey] : undefined;
};

const create = (
  page: number,
  pageSize: number,
  filters: OperatorListingFilter[],
  sortKey: OperatorListingSortKey | null,
): UserOperatorListParams => {
  const statusFilter = filters.find(
    (filter) => filter.type === OperatorListingFilterType.STATUS,
  )?.value as OperatorListingStatusFilter["value"] | undefined;

  return {
    page,
    pageSize,
    firstName: filters.find(
      (filter) => filter.type === OperatorListingFilterType.FIRST_NAME,
    )?.value as OperatorListingFirstNameFilter["value"] | undefined,
    lastName: filters.find(
      (filter) => filter.type === OperatorListingFilterType.LAST_NAME,
    )?.value as OperatorListingLastNameFilter["value"] | undefined,
    email: filters.find(
      (filter) => filter.type === OperatorListingFilterType.EMAIL,
    )?.value as OperatorListingEmailFilter["value"] | undefined,
    username: filters.find(
      (filter) => filter.type === OperatorListingFilterType.USERNAME,
    )?.value as OperatorListingUsernameFilter["value"] | undefined,
    order: createOrder(sortKey),
    status: statusFilter,
  };
};

const OperatorListingLoadParamsFactory = {
  create,
};

export default OperatorListingLoadParamsFactory;
